var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"setting"}},[(_vm.canSupportWebRTC)?_c('CameraMenu'):_vm._e(),(_vm.canSupportWebRTC)?_c('MicMenu'):_vm._e(),_c('SpeakerMenu'),_c('div',{staticClass:"br"}),_c('SettingMenu')],1)}
var staticRenderFns = []

export { render, staticRenderFns }